import {
  CreditAccountTransactionsByFiltersDocument,
  CreditTypeEnum,
  type CreditAccountTransactionsFilter,
} from "@/__generated__/graphql";
import { useAuthState } from "@/store/auth";
import { useQuery } from "@apollo/client";

export const useCreditAccountTransactionByFiltersQuery = (
  filters: CreditAccountTransactionsFilter,
  type: CreditTypeEnum,
  departmentLinkedName?: string,
) => {
  const creditAccounts = useAuthState((state) => state.data.userInfo.creditAccounts);

  const filteredCreditAccounts =
    creditAccounts?.filter((account) => {
      if (account.creditType !== type) {
        return false;
      }

      if (type !== CreditTypeEnum.Department || !departmentLinkedName) {
        return true;
      }

      return (
        account.linkedObject?.linkedType === "Department" &&
        account.linkedObject.name === departmentLinkedName
      );
    }) || [];

  const creditAccountIds = filteredCreditAccounts.map((c) => c.id);

  const result = useQuery(CreditAccountTransactionsByFiltersDocument, {
    skip: creditAccountIds.length === 0,
    variables: {
      filters: {
        ...filters,
        creditAccountId: creditAccountIds,
      },
    },
  });

  const list = result.data?.creditAccountTransactionsByFilters.creditAccountTransactions || [];
  const total = result.data?.creditAccountTransactionsByFilters.count ?? 0;

  return {
    ...result,
    list,
    total,
  };
};
